import type { ReactNode } from "react";

/** Titre de section de la colonne Relances (petites capitales, comme les panneaux de fiche CRM). */
export function SectionTitle({ id, children, aside }: { id?: string; children: ReactNode; aside?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-2">
      <h4 id={id} className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">
        {children}
      </h4>
      {aside}
    </div>
  );
}
